var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('hero',{attrs:{"heading":_vm.heading}}),_c('app-section',[_c('project-list',{attrs:{"projects":_vm.projects,"showAttr":true,"blink":_vm.blinkAttr}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }